import $ from "jquery";
import Api from "./api";
import Logger from "./../common/logger";
import Notification from "./../common/notification";

import Resources from "../resources";
import Tracker from "../common/tracker";
import Cookies from "../http/cookies";
import PlaceAutocomplete from "./fields/placeAutocomplete";
import Text from "./fields/text";
import Textarea from "./fields/textarea";
import Email from "./fields/email";
import Beds from "./fields/beds";
import Baths from "./fields/baths";
import PropertyTypes from "./fields/propertyTypes";
import SectionBreak from "./fields/section-break";
import {
  isEmpty,
  objectToQueryString,
  queryStringToObject,
} from "../common/util";
import Phone from "./phone";
import State from "./fields/state";

const Amp = (($) => {
  const Modes = {
    Requests: "requests",
    Calls: "calls",
  };
  const CookieTypes = {
    Lead: "lead",
    Profile: "profile",
    Property: "property",
  };
  const Styles = {
    Stepped: "stepped",
    OneStep: "one",
  };

  const Default = {
    mode: Modes.Requests,
    style: Styles.Stepped,
    step: 1,
    delimiter: "-",
    successUrl: null,
    placeholderText: "What is your address?",
  };

  const Status = {
    Loading: 0,
    Default: 1,
    Submitting: 2,
    Success: 3,
  };

  class Amp {
    constructor(element, config) {
      this._id = "ion_amp_" + new Date().getTime();
      this._element = element;
      this._profile = null;
      this._lead = null;
      this._data = null;
      this._form = null;
      this._fields = [];
      this._fieldMap = {};
      this._status = Status.Loading;
      this._values = {};
      this._errors = {};
      this._cache = {};
      this._config = {
        ...Default,
        ...$(this._element).data(),
        ...config,
      };

      this.load();
    }

    getConfig(name, defaultValue = null) {
      if (this._config[name]) {
        return this._config[name];
      }
      return defaultValue;
    }

    getID() {
      return this._id;
    }

    setValues(values) {
      this._values = {
        ...this._values,
        ...values,
      };
    }

    load() {
      const self = this;

      if (!this._config.name) {
        Logger.warn("The name or is not supplied for the AMP Plugin.");
      }

      Api.getProfile(this._config.name).done((data) => {
        this._profile = data;
        if (this._config.mode == Modes.Requests) {
          if (this._config.style == Styles.Stepped) {
            if (this._config.step == 1) {
              this._status = Status.Default;
              self.build();
            } else if (this._config.step == 2) {
              const cookie = this.getConfig("cookie", "yes");
              var leadID = null;
              if (cookie == "no") {
                const qs = queryStringToObject(location.search);
                leadID = qs.leadID;
              } else {
                leadID = this.getCookie(CookieTypes.Lead);
              }
              if (!leadID || !leadID.match(/^[0-9]+$/)) {
                Logger.warn(
                  "Ion Amp: Step 2 could not find a lead identifier."
                );
                const redirectUrl = this.getConfig("redirectUrl");
                if (redirectUrl) {
                  window.location.href = redirectUrl;
                }
                return;
              }
              Api.getRentalAnalysisRequest(
                this._profile.rentalAnalysisProfile.rentalAnalysisProfileID,
                leadID
              )
                .done((response) => {
                  this._lead = response.rentalAnalysisRequest;
                  this.build();
                })
                .fail((response) => {
                  Logger.warn("Failed to find Rental Analysis Request");
                });
            } else {
              Logger.warn("Ion Amp: Step is not supported");
            }
          } else {
            self.build();
          }
        } else if (this._config.mode == Modes.Calls) {
          if (
            this._profile.trackingNumberProfile &&
            this._profile.trackingNumberProfile.trackingNumber
          ) {
            new Phone(this._element, {}, this._profile.trackingNumberProfile);
          }
        }
      });
    }

    onPropertyAddressSelected(address, place) {
      this._values.step1 = address;
    }

    onContactAddressSelected(address, place) {
      Object.keys(address).forEach((prop) => {
        const element = $(`:input[name='${prop}']`, this._form);
        element.val(address[prop]);
      });
    }

    build() {
      const self = this;

      this._form = document.createElement("form");
      this._form.classList.add("ion-amp-form", "ion-form");

      if (this._config.style == Styles.Stepped) {
        if (this._config.step == 1) {
          this._fields = [
            new PlaceAutocomplete({
              label: "Property Address",
              placeholder: this.getConfig("placeholder", "Property Address"),
              name: "propertyAddress",
              onChange: (address, place) => {
                this.onPropertyAddressSelected(address, place);
              },
            }),
          ];
        } else if (this._config.step == 2) {
          $(".ion-amp-lead-address").text(this._lead.propertyAddress);
          $(".ion-amp-lead-address-full").text(`
            ${this._lead.propertyAddress}  ${this._lead.propertyCity}, ${this._lead.propertyStateID} ${this._lead.propertyPostalCode}`);
          this._fields = [
            new SectionBreak({
              label: "Property Information",
            }),
            new Beds({
              label: "Beds",
              name: "beds",
              isRequired: true,
            }),
            new Baths({
              label: "Baths",
              name: "baths",
              isRequired: true,
            }),
            new PropertyTypes({
              label: "Property Type",
              name: "propertyType",
              isRequired: true,
            }),
            new Text({
              label: "Square Feet",
              name: "area",
              maxLength: 20,
              isRequired: true,
            }),
            new SectionBreak({
              label: "Contact Information",
            }),
            new Text({
              label: "Name",
              name: "contactName",
              isRequired: true,
            }),
            new Email({
              label: "Email",
              name: "contactEmail",
              isRequired: true,
            }),
            new Text({
              label: "Phone",
              name: "contactPhone",
              isRequired: true,
            }),
            new Textarea({
              label: "Comments",
              name: "comments",
            }),
            new SectionBreak({
              label: "Mailing Address",
            }),
            new PlaceAutocomplete({
              label: "Address",
              name: "contactAddress",
              isRequired: true,
              onChange: (address, place) => {
                this.onContactAddressSelected(address, place);
              },
              addressAlias: {
                address: "contactAddress",
                address2: "contactAddress2",
                city: "contactCity",
                state: "contactStateID",
                postalCode: "contactPostalCode",
              },
            }),
            new Text({
              label: "Unit/Suite/Apt #",
              name: "contactAddress2",
            }),
            new Text({
              label: "City",
              name: "contactCity",
              isRequired: true,
            }),
            new State({
              label: "State",
              name: "contactStateID",
              isRequired: true,
            }),
            new Text({
              label: "Zip Code",
              name: "contactPostalCode",
              isRequired: true,
            }),
          ];
        } else {
          Logger.warn(
            "The 'step' attribute for the AMP Plugin is not supported."
          );
        }
      } else {
        this._fields = [
          new PlaceAutocomplete({
            label: "Property Address",
            placeholder: this.getConfig("placeholder", "Property Address"),
            name: "propertyAddress",
            isRequired: true,
            onChange: (address, place) => {
              this.onPropertyAddressSelected(address, place);
            },
          }),
          new SectionBreak({
            label: "Property Information",
          }),
          new Beds({
            label: "Beds",
            name: "beds",
            isRequired: true,
          }),
          new Baths({
            label: "Baths",
            name: "baths",
            isRequired: true,
          }),
          new PropertyTypes({
            label: "Property Type",
            name: "propertyType",
            isRequired: true,
          }),
          new Text({
            label: "Square Feet",
            name: "area",
            maxLength: 20,
            isRequired: true,
          }),
          new SectionBreak({
            label: "Contact Information",
          }),
          new Text({
            label: "Name",
            name: "contactName",
            isRequired: true,
          }),
          new Email({
            label: "Email",
            name: "contactEmail",
            isRequired: true,
          }),
          new Text({
            label: "Phone",
            name: "contactPhone",
            isRequired: true,
          }),
          new Textarea({
            label: "Comments",
            name: "comments",
          }),
          new SectionBreak({
            label: "Mailing Address",
          }),
          new PlaceAutocomplete({
            label: "Address",
            name: "contactAddress",
            isRequired: true,
            onChange: (address, place) => {
              this.onContactAddressSelected(address, place);
            },
            addressAlias: {
              address: "contactAddress",
              address2: "contactAddress2",
              city: "contactCity",
              state: "contactStateID",
              postalCode: "contactPostalCode",
            },
          }),
          new Text({
            label: "Unit/Suite/Apt #",
            name: "contactAddress2",
          }),
          new Text({
            label: "City",
            name: "contactCity",
            isRequired: true,
          }),
          new Text({
            label: "State",
            name: "contactStateID",
            isRequired: true,
          }),
          new Text({
            label: "Zip Code",
            name: "contactPostalCode",
            isRequired: true,
          }),
        ];
      }

      this._fieldMap = {};
      if (this._fields && this._fields.length > 0) {
        this._fields.forEach((field) => {
          if (!field._field.name) {
            this._fieldMap[field._field.name] = field;
          }
        });
      }

      Resources.waitForGoogleMaps(() => {
        this.render();
        this.bindEvents();
      });
    }

    clearCookie(name) {
      Cookies.set(
        `ion-amp-${name}-${this._profile.rentalAnalysisProfile.rentalAnalysisProfileID}`,
        null,
        -5
      );
    }

    setCookie(name, value) {
      Cookies.set(
        `ion-amp-${name}-${this._profile.rentalAnalysisProfile.rentalAnalysisProfileID}`,
        value,
        30
      );
    }

    getCookie(name) {
      return Cookies.get(
        `ion-amp-${name}-${this._profile.rentalAnalysisProfile.rentalAnalysisProfileID}`
      );
    }

    renderSuccess() {
      $(this._element)
        .empty()
        .append(
          "<h3>Thank you for your inquiry!</h3><p>Your information has been submitted and your FREE Rental Analysis will be emailed to you shortly.</p>"
        );
    }

    render() {
      const self = this;
      const id = this._id + "_submit_btn";
      this._form.innerHTML = "";

      this._fields.forEach((field, index) => {
        field.setForm(self);
        field.render();
        self._form.appendChild(field.getElement());
      });

      this._button = document.createElement("button");
      this._button.id = id;
      this._button.type = "submit";
      this._button.innerText = "Submit";
      this._button.classList.add("ion-btn");
      this._form.appendChild(this._button);

      this._element.appendChild(this._form);
    }

    bindEvents() {
      const self = this;
      this._form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.onSubmit(e);
      });
    }

    bindErrors() {
      this._fields.forEach((field) => {
        field.clearMessages();

        const errors = this._errors[field._field.name];
        if (errors && errors.length > 0) {
          field.appendMessages(errors);
        }
      });
    }

    submitting() {
      this._status = Status.Submitting;
      if (this._button) {
        this._button.innerText = "Submitting...";
        this._button.classList.add("ion-form-btn-inactive");
      }
    }

    stopSubmitting() {
      this._status = Status.Default;
      if (this._button) {
        this._button.innerText = "Submit";
        this._button.classList.remove("ion-form-btn-inactive");
      }
    }

    validateStep1(data) {
      this._errors = {};

      if (!data.propertyAddress) {
        this._errors["propertyAddress"] = "Property Address is Required";
      }

      if (Object.keys(this._errors).length > 0) {
        new Notification(
          "Error Occurred",
          "Please make sure you selected an address.",
          "error",
          true
        );
        return false;
      }

      return true;
    }

    validateStep2(data) {
      this._errors = {};

      if (isEmpty(data.beds)) {
        this._errors["beds"] = ["Beds is Required"];
      }

      if (isEmpty(data.baths)) {
        this._errors["baths"] = ["Baths is Required"];
      }

      if (isEmpty(data.area)) {
        this._errors["area"] = ["Square Feet is Required"];
      }

      if (isEmpty(data.contactName)) {
        this._errors["contactName"] = ["Name is Required"];
      }

      if (isEmail(!data.contactEmail)) {
        this._errors["contactEmail"] = ["Valid Email is Required"];
      }

      if (isEmpty(data.contactPhone)) {
        this._errors["contactPhone"] = ["Phone is Required"];
      }

      if (Object.keys(this._errors).length > 0) {
        new Notification(
          "Error Occurred",
          "Please make sure you selected an address.",
          "error",
          true
        );
        return false;
      }

      return true;
    }

    validateOneStep(data) {
      if (this.validateStep1(data) && this.validateStep2(data)) {
        return true;
      }
      return false;
    }

    onSubmit(e) {
      if (this._status == Status.Submitting) {
        e.preventDefault();
        return;
      }

      this.submitting();

      const profileID =
        this._profile.rentalAnalysisProfile.rentalAnalysisProfileID;

      if (this._config.style == Styles.Stepped) {
        if (this._config.step == 1) {
          const data = { ...this._values.step1 };
          if (this.validateStep1(data)) {
            Api.submitRentalAnalysisStepOne(profileID, data)
              .then((response) => {
                const cookie = this.getConfig("cookie", "yes");
                const successUrl = this.getConfig("successUrl");
                if (!successUrl) {
                  Logger.warn("Success URL is not defined for AMP Step 1");
                }

                if (successUrl) {
                  if (cookie == "no") {
                    const qs = objectToQueryString({
                      ...data,
                      leadID:
                        response.rentalAnalysisRequest.rentalAnalysisRequestID,
                      profileSlug: this._profile.rentalAnalysisProfile.slug,
                    });
                    if (successUrl.indexOf("?") >= 0) {
                      window.location.href = `${successUrl}&${qs}`;
                    } else {
                      window.location.href = `${successUrl}?${qs}`;
                    }
                  } else {
                    this.setCookie(
                      CookieTypes.Lead,
                      response.rentalAnalysisRequest.rentalAnalysisRequestID
                    );

                    this.setCookie(
                      CookieTypes.Profile,
                      this._profile.rentalAnalysisProfile.slug
                    );

                    this.setCookie(CookieTypes.Property, data);

                    window.location.href = successUrl;
                  }
                } else {
                  Logger.warn("Ion Amp: No Success URL is present.");
                }
              })
              .fail((response) => {
                new Notification(
                  "Error Occurred",
                  "Please make sure you selected an address.",
                  "error",
                  true
                );
                this.stopSubmitting();
              });
          } else {
            this._status = Status.Default;
          }
        } else if (this._config.step == 2) {
          const array = $(this._form).serializeArray();
          const data = {};
          const requestID = this._lead.rentalAnalysisRequestID;

          array.forEach((item) => {
            data[item.name] = item.value;
          });

          //if(this.validateStep2(data))

          Api.submitRentalAnalysisStepTwo(profileID, requestID, data)
            .then((response) => {
              this.clearCookie(CookieTypes.Lead);
              this.clearCookie(CookieTypes.Profile);
              this.clearCookie(CookieTypes.Property);

              const successUrl = this.getConfig("successUrl");
              if (successUrl) {
                window.location.href = successUrl;
              } else {
                this.renderSuccess();
              }
            })
            .fail((response) => {
              new Notification(
                "Error Occurred",
                "Please review the form and try again.",
                "error",
                true
              );
              this._errors = response.responseJSON;
              this.bindErrors();
              this.stopSubmitting();
            });
        } else {
          this._status = Status.Default;
          Logger.error(`Step '${this._config.step}' is not supported`);
        }
      } else {
        let data = {};
        const array = $(this._form).serializeArray();
        array.forEach((item) => {
          data[item.name] = item.value;
        });
        data = { ...data, ...this._values.step1 };

        Api.submitRentalAnalysis(profileID, data)
          .then((response) => {
            const successUrl = this.getConfig("successUrl");
            if (successUrl) {
              window.location.href = successUrl;
            } else {
              this.renderSuccess();
            }
          })
          .fail((response) => {
            new Notification(
              "Error Occurred",
              "Please review the form and try again.",
              "error",
              true
            );
            this._errors = response.responseJSON;
            this.bindErrors();
            this.stopSubmitting();
          });
      }
    }
  }

  // Data API
  $("[data-ion='amp']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.amp");

    if (!data) {
      data = new Amp(element);
      $element.data("ion.amp", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });

  return Amp;
})($);

export default Amp;
